import { TransText } from '@/i18n/trans/text';
import type { SearchNonTripOffersDTO } from '@/types/dto/agent';
import { Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

export const NonTripOffersNotFound: FC<SearchNonTripOffersDTO> = ({
  nonTripOffers,
}) => {
  if (!nonTripOffers || nonTripOffers.length > 0) {
    return null;
  }

  return (
    <div className="mx-auto w-fit px-4 py-8 laptop:px-0">
      <Typography
        className="text-neutral"
        variant="paragraph"
        data-testid="no-travel-passes-found-message"
      >
        <TransText i18nKey="noTravelPassesFoundPleaseChangeSearchInputsAndTryAgain" />
      </Typography>
    </div>
  );
};
